import React from 'react';
import { PropTypes } from 'prop-types';
import { CircularProgress } from '@mui/material';


const Spinner = ({ size = 40, ...props}) => (
  <div className="spinner-container">
    <CircularProgress
      {...props}
      size={size}
      className="spinner"
    />
  </div>
);

Spinner.propTypes = {
  size: PropTypes.number,
};

export default Spinner;
